import { forwardRef, useCallback, useMemo, useState } from "react";
import moment from "moment";
import IntlMessages from "../../../../@richbeauty/utility/IntlMessages";
import AppFormModal from "../../../../@richbeauty/core/AppFormModal";
import useCreateOrEditTaskFieldConfig from "./useCreateOrEditTaskFieldConfig";
import { revalidateTasks } from "../../../../@richbeauty/utility/helper/cacheRevalidator";
import toast from "react-hot-toast";
import useUpdateTask from "hooks/apis/task/useUpdateTask";
import useGetTask from "hooks/apis/task/useGetTask";

const EditTaskModal = forwardRef(({ id }, ref) => {
  const { data: dataGetTask } = useGetTask(id);
  const { trigger: triggerEditTask, isMutating: isMutatingEditTask } = useUpdateTask();

  const [formData, setFormData] = useState({});
  const formattedData = useMemo(() => {
    if (!dataGetTask) return {};
    const task = dataGetTask;
    const updateData = {
      ...task,
      dueDate: task.dueDate ? moment(task.dueDate) : null,
    }
    setFormData(updateData);
    return updateData;
  }, [dataGetTask]);
  const createOrEditTaskFieldConfig = useCreateOrEditTaskFieldConfig(formData, false);

  const onHandleEditTask = useCallback(
    (formData) => {
      triggerEditTask(
        { ...formData, id },
        {
          onSuccess: () => {
            revalidateTasks();
            ref.current?.closeModal && ref.current.closeModal();
          },
          onError: (error) => {
            toast.error(error?.message);
          },
        }
      );
    },
    [triggerEditTask, ref, id]
  );


  return (
    <AppFormModal
      ref={ref}
      data={formattedData}
      title={<IntlMessages id="task.edit" defaultMessage="Edit Task" />}
      onFinish={onHandleEditTask}
      isSubmitting={isMutatingEditTask}
      fieldsConfig={createOrEditTaskFieldConfig}
      onValuesChange={(data) => setFormData(data?.allValues)}
    />
  );
});

export default EditTaskModal;
